import { englishMessages } from './common';

export default {
  ...englishMessages,
  'input.placeholder': 'Votre recherche/OnlineCode',

  'search.result.consumption': 'Consommation',
  'watch.video': 'Regarder la vidéo',
  'input.recently': 'Récemment recherché',
  'input.help.title': 'Que devriez-vous recherchez ?',
  'input.help.text':
    "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

  'search.result.grid': 'Grille',
  'search.result.list': 'Liste',
};
